import { useState, useRef, useEffect } from 'react'

export default function Tooltip({ children, content, position = 'top', delay = 300 }) {
  const [show, setShow] = useState(false)
  const timer = useRef(null)

  const handleMouseEnter = () => {
    timer.current = setTimeout(() => {
      setShow(true)
    }, delay)
  }

  const handleMouseLeave = () => {
    clearTimeout(timer.current)
    setShow(false)
  }

  useEffect(() => {
    return () => clearTimeout(timer.current)
  }, [])

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  }

  const arrowClasses = {
    top: 'top-full left-1/2 -translate-x-1/2 border-t-dark-700',
    bottom: 'bottom-full left-1/2 -translate-x-1/2 border-b-dark-700',
    left: 'left-full top-1/2 -translate-y-1/2 border-l-dark-700',
    right: 'right-full top-1/2 -translate-y-1/2 border-r-dark-700',
  }

  if (!content) return children

  return (
    <div className="relative flex items-center" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {children}
      {show && (
        <div className={`absolute z-[100] whitespace-nowrap px-2 py-1 text-[11px] font-medium text-white bg-dark-800 border border-dark-700 rounded shadow-xl animate-in fade-in zoom-in-95 duration-150 ${positionClasses[position]}`}>
          {content}
          <div className={`absolute border-4 border-transparent ${arrowClasses[position]}`} />
        </div>
      )}
    </div>
  )
}
